import { render } from "./MandakovicTitle.vue?vue&type=template&id=a50ce4ee&scoped=true"
import script from "./MandakovicTitle.vue?vue&type=script&lang=js"
export * from "./MandakovicTitle.vue?vue&type=script&lang=js"

import "./MandakovicTitle.vue?vue&type=style&index=0&id=a50ce4ee&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50ce4ee"]])

export default __exports__